import React from 'react';
import classnames from 'classnames';
import Element from '../../element';
import styles from './card.module.scss';

interface IProps {
    className?: string;
    children?: React.ReactNode;
}

export default function CardFooter({ className, children, ...rest }: IProps) {
    return (
        <Element
            className={classnames(styles['bm-card-footer'], className)}
            {...rest}
        >
            {children}
        </Element>
    );
}
